import ContentEditable from "react-contenteditable";
import type { Pattern } from "src/types";
import styled from "styled-components";

export const StyledContentEditable = styled(ContentEditable)<{
  pattern: Pattern;
}>`
  position: relative;
  word-break: break-word;
  hyphens: manual;
`;
